import {
  BottleIcon,
  ContactIcon,
  DocIcon,
  EuroIcon,
  FaqIcon,
  FidelityIcon,
  FormationIcon,
  HomeIcon,
  JobIcon,
  LibraryIcon,
  MinisiteIcon,
  OperationIcon,
  ProfilIcon,
  ServiceIcon,
  SpeakerIcon,
  StarIcon,
  StoreIcon,
  UserIcon,
  TermsIcon,
  BalanceIcon,
  WorldHouseIcon,
  VistaprintIcon,
  PromoIcon,
  TeamIcon,
  MassAdminIcon,
  AlmaIcon,
  MiaIcon
} from 'app/main/components/icons';
import { Apps as AppsIcon } from '@material-ui/icons';
import i18next from 'i18next';
import userRoles from 'app/userRoles';
import en from './navigation-i18n/en';
import es from './navigation-i18n/es';
import fr from './navigation-i18n/fr';
import it from './navigation-i18n/it';
import pl from './navigation-i18n/pl';
import pt from './navigation-i18n/pt';

const {
  ROLE_MINISITE_MASS_ADMINISTRATION_PRICE_ALL,
  ROLE_MINISITE_MASS_ADMINISTRATION_PRICE_LIST,
  ROLE_MINISITE_MASS_ADMINISTRATION_MESSAGE_ALL,
  ROLE_MINISITE_MASS_ADMINISTRATION_MESSAGE_SHOW,
  ROLE_MINISITE_MASS_ADMINISTRATION_MESSAGE_LIST,
  ROLE_MINISITE_MASS_ADMINISTRATION_MESSAGE_ADD,
  ROLE_MINISITE_MASS_ADMINISTRATION_MESSAGE_EDIT,
  ROLE_MINISITE_MASS_ADMINISTRATION_MESSAGE_DELETE,
  ROLE_MINISITE_MASS_ADMINISTRATION_TAG_ALL,
  ROLE_MINISITE_MASS_ADMINISTRATION_TAG_SHOW,
  ROLE_MINISITE_MASS_ADMINISTRATION_TAG_LIST,
  ROLE_MINISITE_MASS_ADMINISTRATION_TAG_ADD,
  ROLE_MINISITE_MASS_ADMINISTRATION_TAG_EDIT,
  ROLE_MINISITE_MASS_ADMINISTRATION_TAG_DELETE,
  ROLE_MINISITE_MASS_ADMINISTRATION_PICTURE_ALL,
  ROLE_MINISITE_MASS_ADMINISTRATION_PICTURE_SHOW,
  ROLE_MINISITE_MASS_ADMINISTRATION_PICTURE_LIST,
  ROLE_MINISITE_MASS_ADMINISTRATION_PICTURE_ADD,
  ROLE_MINISITE_MASS_ADMINISTRATION_PICTURE_EDIT,
  ROLE_MINISITE_MASS_ADMINISTRATION_PICTURE_DELETE,
  ROLE_LEGAL_ALL,
  ROLE_LEGAL_LIST,
  ROLE_LEGAL_SHOW,
  ROLE_LEGAL_ADD,
  ROLE_LEGAL_EDIT,
  ROLE_LEGAL_DELETE,
  ROLE_SUPER_ADMIN,
  ROLE_ADMIN,
  ROLE_MESSAGE,
  ROLE_MESSAGE_LIST,
  ROLE_SALONMANAGER_ALL,
  ROLE_SALONMANAGER_LIST,
  ROLE_SALON_ALL,
  ROLE_SALON_LIST,
  ROLE_SALON_ADD,
  ROLE_NEWS,
  ROLE_NEWS_LIST,
  ROLE_HEADER,
  ROLE_HEADER_LIST,
  ROLE_FEEDBACK,
  ROLE_FEEDBACK_LIST,
  ROLE_COMMENT,
  ROLE_COMMENT_LIST,
  ROLE_NATIONAL_OPERATION_ALL,
  ROLE_NATIONAL_OPERATION_LIST,
  ROLE_NATIONAL_OPERATION_ADD,
  ROLE_OPERATIONMANAGER_ALL,
  ROLE_OPERATIONMANAGER_LIST,
  ROLE_NATIONAL_PRICE_ALL,
  ROLE_NATIONAL_PRICE_LIST,
  ROLE_JOB,
  ROLE_JOB_ALL,
  ROLE_JOB_LIST,
  ROLE_JOB_ADD,
  ROLE_SERVICE_ALL,
  ROLE_SERVICE_LIST,
  ROLE_SERVICE_ADD,
  ROLE_SERVICEMANAGER_ALL,
  ROLE_SERVICEMANAGER_LIST,
  ROLE_CONTACT,
  ROLE_CONTACT_LIST,
  ROLE_ORIGIN_ALL,
  ROLE_ORIGIN_LIST,
  ROLE_ORIGIN_ADD,
  ROLE_USERMANAGER_ALL,
  ROLE_USERMANAGER_LIST,
  ROLE_USERMANAGER_ADD,
  ROLE_GROUP_ALL,
  ROLE_GROUP_LIST,
  ROLE_GROUP_ADD,
  ROLE_MAJSITE,
  ROLE_SUCCURSALE,
  ROLE_FRANCHISE,
  ROLE_DOC_FILES_LIST,
  ROLE_FAQ_ALL,
  ROLE_FAQ_LIST,
  FRANCHISEE_LIBRARY_CONTENT_ALL,
  FRANCHISEE_LIBRARY_CONTENT_LIST,
  FRANCHISEE_FAQ_ALL,
  FRANCHISEE_FAQ_LIST,
  FRANCHISEE_COLLABORATOR_MANAGERS_ALL,
  FRANCHISEE_COLLABORATOR_MANAGERS_LIST,
  ROLE_COLLABORATOR_MANAGERS_ALL,
  ROLE_COLLABORATOR_MANAGERS_SHOW,
  ROLE_COLLABORATOR_MANAGERS_LIST,
  FRANCHISEE_CODES_LIST,
  FRANCHISEE_BULK_PRICES_AND_OPERATIONS_ALL
} = userRoles;

i18next.addResourceBundle('fr', 'navigation', fr);
i18next.addResourceBundle('en', 'navigation', en);
i18next.addResourceBundle('es', 'navigation', es);
i18next.addResourceBundle('it', 'navigation', it);
i18next.addResourceBundle('pt', 'navigation', pt);
i18next.addResourceBundle('pl', 'navigation', pl);

const navigationConfig = [
  {
    id: 'dashboard-group',
    title: 'Dashboard',
    type: 'collapse',
    icon: HomeIcon,
    url: '/dashboard',
    translate: 'dashboard',
    display: 'reseau',
    children: [
      {
        id: 'dashboard-list-component',
        title: 'Dashboard',
        type: 'item',
        url: '/dashboard',
        translate: 'home_dashboard',
        exact: true
      },
      {
        id: 'dashboard-news-list-component',
        title: 'Listes des news',
        type: 'item',
        auth: [ROLE_SUPER_ADMIN, ROLE_ADMIN, ROLE_NEWS, ROLE_NEWS_LIST],
        url: '/dashboard/news',
        translate: 'dashboard_news'
      },
      {
        id: 'dashboard-slides-list-component',
        title: 'Listes des slides',
        type: 'item',
        auth: [ROLE_SUPER_ADMIN, ROLE_ADMIN, ROLE_HEADER, ROLE_HEADER_LIST],
        url: '/dashboard/slides',
        translate: 'dashboard_slides'
      },
      {
        id: 'dashboard-notifications-list-component',
        title: 'Listes des notifications',
        type: 'item',
        auth: [ROLE_SUPER_ADMIN, ROLE_ADMIN, ROLE_MESSAGE, ROLE_MESSAGE_LIST],
        url: '/dashboard/notifications',
        translate: 'dashboard_notifications'
      }
    ]
  },
  {
    id: 'hairdressers-network',
    title: 'Réseau de salons',
    auth: [
      ROLE_SUPER_ADMIN,
      ROLE_ADMIN,
      ROLE_SALON_ALL,
      ROLE_SALONMANAGER_ALL,
      ROLE_SALON_LIST,
      ROLE_SALON_ADD
    ],
    display: 'reseau',
    type: 'group',
    icon: AppsIcon,
    translate: 'hairdressers_network',
    children: [
      {
        id: 'hairdresser-group',
        title: 'Salons de coiffure',
        type: 'collapse',
        icon: StoreIcon,
        exact: true,
        url: '/hairdressers',
        translate: 'hairdressers',
        display: 'reseau',
        auth: [
          ROLE_SUPER_ADMIN,
          ROLE_ADMIN,
          ROLE_SALON_ALL,
          ROLE_SALON_LIST,
          ROLE_SALON_ADD,
          ROLE_SALONMANAGER_ALL
        ],
        children: [
          {
            id: 'hairdressers-list-component',
            title: 'Liste des salons',
            auth: [
              ROLE_SALON_ALL,
              ROLE_SALON_LIST,
              ROLE_SUPER_ADMIN,
              ROLE_ADMIN
            ],
            type: 'item',
            exact: true,
            url: '/hairdressers',
            translate: 'hairdressers_list'
          },
          {
            id: 'haidressers-list-manager-component',
            title: 'Associer un salon',
            auth: [
              ROLE_SALONMANAGER_ALL,
              ROLE_SALONMANAGER_LIST,
              ROLE_ADMIN,
              ROLE_SUPER_ADMIN
            ],
            type: 'item',
            url: '/hairdressers/association',
            translate: 'link_hairdresser_supervisor'
          }
        ]
      },
      {
        id: 'hairdresser-minisite-group',
        title: 'Minisite',
        type: 'collapse',
        icon: MinisiteIcon,
        exact: true,
        url: '/minisite',
        translate: 'minisite',
        display: 'reseau',
        auth: [
          ROLE_SUPER_ADMIN,
          ROLE_ADMIN,
          ROLE_MAJSITE,
          ROLE_SUCCURSALE,
          ROLE_FRANCHISE
        ],
        children: [
          {
            id: 'hairdressers-list-component',
            title: 'minisiteList',
            auth: [ROLE_MAJSITE, ROLE_ADMIN, ROLE_SUPER_ADMIN],
            type: 'item',
            exact: true,
            url: '/minisite',
            translate: 'minisiteList'
          },
          {
            id: 'minisite-message-list-component',
            title: 'minisiteMessageList',
            auth: [ROLE_SUCCURSALE, ROLE_SUPER_ADMIN, ROLE_ADMIN],
            type: 'item',
            exact: true,
            url: '/minisite/messages',
            translate: 'minisiteMessageList'
          },
          {
            id: 'minisite-tag-list-component',
            title: 'minisiteTagList',
            auth: [ROLE_FRANCHISE, ROLE_ADMIN, ROLE_SUPER_ADMIN],
            type: 'item',
            exact: true,
            url: '/minisite/tags',
            translate: 'minisiteTagList'
          }
        ]
      },
      {
        id: 'hairdresser-administration-group',
        title: 'Mass administration',
        type: 'collapse',
        icon: MinisiteIcon,
        exact: true,
        url: '/administration/prices',
        translate: 'minisiteMassiveImport',
        display: 'reseau',
        auth: [
          ROLE_SUPER_ADMIN,
          ROLE_MINISITE_MASS_ADMINISTRATION_PRICE_ALL,
          ROLE_MINISITE_MASS_ADMINISTRATION_PRICE_LIST,
          ROLE_MINISITE_MASS_ADMINISTRATION_MESSAGE_ALL,
          ROLE_MINISITE_MASS_ADMINISTRATION_MESSAGE_LIST,
          ROLE_MINISITE_MASS_ADMINISTRATION_TAG_ALL,
          ROLE_MINISITE_MASS_ADMINISTRATION_TAG_LIST,
          ROLE_MINISITE_MASS_ADMINISTRATION_PICTURE_ALL,
          ROLE_MINISITE_MASS_ADMINISTRATION_PICTURE_LIST
        ],
        children: [
          {
            id: 'administration-tag-list-component',
            title: 'minisiteList',
            auth: [
              ROLE_SUPER_ADMIN,
              ROLE_MINISITE_MASS_ADMINISTRATION_TAG_LIST,
              ROLE_ADMIN,
              ROLE_SUPER_ADMIN
            ],
            type: 'item',
            exact: true,
            url: '/administration/tags',
            translate: 'mass_administration_tag_list'
          },
          {
            id: 'administration-businessHours-list-component',
            title: 'minisiteList',
            auth: [
              ROLE_SUPER_ADMIN,
              ROLE_MINISITE_MASS_ADMINISTRATION_PRICE_LIST,
              ROLE_ADMIN,
              ROLE_SUPER_ADMIN
            ],
            type: 'item',
            exact: true,
            url: '/administration/businessHours',
            translate: 'mass_administration_businessHours_list'
          },
          {
            id: 'administration-message-list-component',
            title: 'minisiteList',
            auth: [
              ROLE_SUPER_ADMIN,
              ROLE_MINISITE_MASS_ADMINISTRATION_MESSAGE_LIST,
              ROLE_ADMIN,
              ROLE_SUPER_ADMIN
            ],
            type: 'item',
            exact: true,
            url: '/administration/messages',
            translate: 'mass_administration_message_list'
          },
          {
            id: 'administration-price-list-component',
            title: 'minisiteList',
            auth: [
              ROLE_SUPER_ADMIN,
              ROLE_MINISITE_MASS_ADMINISTRATION_PRICE_LIST,
              ROLE_ADMIN,
              ROLE_SUPER_ADMIN
            ],
            type: 'item',
            exact: true,
            url: '/administration/prices',
            translate: 'mass_administration_price_list'
          },
          {
            id: 'administration-picture-list-component',
            title: 'minisiteList',
            auth: [
              ROLE_SUPER_ADMIN,
              ROLE_MINISITE_MASS_ADMINISTRATION_PICTURE_LIST,
              ROLE_ADMIN,
              ROLE_SUPER_ADMIN
            ],
            type: 'item',
            exact: true,
            url: '/administration/pictures',
            translate: 'mass_administration_picture_list'
          }
        ]
      }
    ]
  },
  {
    id: 'provalliance',
    title: 'Provalliance',
    auth: [
      ROLE_NATIONAL_PRICE_ALL,
      ROLE_NATIONAL_OPERATION_ALL,
      ROLE_SERVICE_ALL,
      ROLE_JOB_ALL,
      ROLE_ADMIN,
      ROLE_SUPER_ADMIN
    ],
    type: 'group',
    display: 'reseau',
    children: [
      {
        id: 'legal-component',
        title: 'Prestations & tarifs',
        auth: [
          ROLE_LEGAL_ALL,
          ROLE_LEGAL_LIST,
          ROLE_ADMIN,
          ROLE_SUPER_ADMIN,
          ROLE_NATIONAL_PRICE_ALL,
          ROLE_NATIONAL_PRICE_LIST
        ],
        type: 'collapse',
        url: '/national/prices',
        display: 'reseau',
        icon: EuroIcon,
        translate: 'prices',
        exact: true,
        children: [
          {
            id: 'services-prices-list-component',
            title: 'Liste des prestations & tarifs',
            auth: [
              ROLE_NATIONAL_PRICE_ALL,
              ROLE_NATIONAL_PRICE_LIST,
              ROLE_ADMIN,
              ROLE_SUPER_ADMIN
            ],
            type: 'item',
            url: '/national/prices',
            translate: 'prices_list',
            exact: true
          },
          {
            id: 'legal-list-component',
            title: 'Liste des mentions légales',
            auth: [
              ROLE_LEGAL_ALL,
              ROLE_LEGAL_LIST,
              ROLE_ADMIN,
              ROLE_SUPER_ADMIN
            ],
            type: 'item',
            url: '/legals',
            translate: 'legals_list',
            exact: true
          },
          {
            id: 'legal-participate-component',
            title: 'Associer une mention légale',
            auth: [
              ROLE_OPERATIONMANAGER_ALL,
              ROLE_OPERATIONMANAGER_LIST,
              ROLE_ADMIN,
              ROLE_SUPER_ADMIN
            ],
            type: 'item',
            url: '/legals/participate',
            translate: 'legals_participate'
          }
        ]
      },
      {
        id: 'opnational-component',
        title: 'Opérations nationales',
        auth: [
          ROLE_NATIONAL_OPERATION_ALL,
          ROLE_NATIONAL_OPERATION_LIST,
          ROLE_ADMIN,
          ROLE_SUPER_ADMIN
        ],
        type: 'collapse',
        url: '/national/operations',
        display: 'reseau',
        icon: OperationIcon,
        translate: 'national_operations',
        exact: true,
        children: [
          {
            id: 'opnational-list-component',
            title: 'Liste des opérations nationales',
            auth: [
              ROLE_NATIONAL_OPERATION_ALL,
              ROLE_NATIONAL_OPERATION_LIST,
              ROLE_ADMIN,
              ROLE_SUPER_ADMIN
            ],
            type: 'item',
            url: '/national/operations',
            translate: 'national_operations_list',
            exact: true
          },
          {
            id: 'opnational-participate-component',
            title: 'Associer une op nationale',
            auth: [
              ROLE_OPERATIONMANAGER_ALL,
              ROLE_OPERATIONMANAGER_LIST,
              ROLE_ADMIN,
              ROLE_SUPER_ADMIN
            ],
            type: 'item',
            url: '/national/operation/participate',
            translate: 'national_operations_participate'
          }
        ]
      },
      {
        id: 'service-component',
        title: 'Services',
        auth: [
          ROLE_SERVICE_ALL,
          ROLE_SERVICE_LIST,
          ROLE_ADMIN,
          ROLE_SUPER_ADMIN
        ],
        display: 'reseau',
        type: 'collapse',
        icon: ServiceIcon,
        url: '/services',
        translate: 'services',
        children: [
          {
            id: 'service-list-component',
            title: 'Liste des services',
            auth: [ROLE_SERVICE_LIST, ROLE_ADMIN, ROLE_SUPER_ADMIN],
            type: 'item',
            url: '/services',
            translate: 'services_list',
            exact: true
          },
          {
            id: 'service-associate-component',
            title: 'Associer un service',
            auth: [
              ROLE_SERVICEMANAGER_ALL,
              ROLE_SERVICEMANAGER_LIST,
              ROLE_ADMIN,
              ROLE_SUPER_ADMIN
            ],
            type: 'item',
            url: '/services/associate',
            translate: 'services_link'
          }
        ]
      },
      {
        id: 'job-component',
        title: "Offres d'emploi",
        auth: [
          ROLE_SUPER_ADMIN,
          ROLE_ADMIN,
          ROLE_JOB,
          ROLE_JOB_LIST,
          ROLE_JOB_ADD
        ],
        display: 'reseau',
        type: 'collapse',
        icon: JobIcon,
        url: '/jobs',
        translate: 'jobs',
        children: [
          {
            id: 'jobs-list-component',
            title: 'Liste des offres',
            auth: [ROLE_JOB_ALL, ROLE_JOB_LIST, ROLE_SUPER_ADMIN, ROLE_ADMIN],
            type: 'item',
            url: '/jobs',
            translate: 'jobs_list'
          }
        ]
      }
    ]
  },
  {
    id: 'customer-relationship',
    title: 'Relation client',
    auth: [
      ROLE_SUPER_ADMIN,
      ROLE_ADMIN,
      ROLE_FEEDBACK,
      ROLE_FEEDBACK_LIST,
      ROLE_COMMENT,
      ROLE_COMMENT_LIST
    ],
    display: 'reseau',
    type: 'group',
    icon: AppsIcon,
    translate: 'customer_relationship',

    children: [
      {
        id: 'feedback-component',
        title: 'Avis clients',
        display: 'reseau',
        auth: [
          ROLE_SUPER_ADMIN,
          ROLE_ADMIN,
          ROLE_FEEDBACK,
          ROLE_FEEDBACK_LIST,
          ROLE_COMMENT,
          ROLE_COMMENT_LIST
        ],
        type: 'collapse',
        icon: StarIcon,
        url: '/feedbacks',
        translate: 'feedbacks',
        exact: true,
        children: [
          {
            id: 'feedback-list-component',
            title: 'Liste des avis',
            auth: [
              ROLE_SUPER_ADMIN,
              ROLE_ADMIN,
              ROLE_FEEDBACK,
              ROLE_FEEDBACK_LIST
            ],
            type: 'item',
            url: '/feedbacks',
            translate: 'feedbacks_list',
            exact: true
          },
          {
            id: 'feedback-model-component',
            title: 'Modèles de réponse',
            auth: [
              ROLE_SUPER_ADMIN,
              ROLE_ADMIN,
              ROLE_COMMENT,
              ROLE_COMMENT_LIST
            ],
            type: 'item',
            url: '/feedbacks/answers',
            translate: 'feedbacks_response_model'
          },
          {
            id: 'feedback-recipient-component',
            title: 'Destinataires des feedbacks',
            auth: [
              ROLE_SUPER_ADMIN,
              ROLE_ADMIN,
              ROLE_FEEDBACK,
              ROLE_FEEDBACK_LIST
            ],
            type: 'item',
            url: '/feedbacks/receivers',
            translate: 'feedbacks_receiver'
          }
        ]
      },
      {
        display: 'reseau',
        id: 'contact-component',
        title: 'Contacts',
        auth: [
          ROLE_SUPER_ADMIN,
          ROLE_ADMIN,
          ROLE_CONTACT,
          ROLE_CONTACT_LIST,
          ROLE_ORIGIN_ALL,
          ROLE_ORIGIN_ADD,
          ROLE_ORIGIN_LIST
        ],
        type: 'collapse',
        icon: ContactIcon,
        url: '/contacts',
        translate: 'contacts',
        children: [
          {
            id: 'contact-list-component',
            title: 'Liste des contacts',
            auth: [
              ROLE_SUPER_ADMIN,
              ROLE_ADMIN,
              ROLE_CONTACT,
              ROLE_CONTACT_LIST
            ],
            type: 'item',
            url: '/contacts',
            translate: 'contacts_list'
          },
          // {
          //     id: 'contact-import-component',
          //     title: 'Importer une liste de contact',
          //     auth: ['ROLE_CONTACT_IMPORT', 'ROLE_CONTACT', 'ROLE_ADMIN', 'ROLE_SUPER_ADMIN'],
          //     type: 'item',
          //     url: '/contact/import',
          //     translate: 'contacts_import',
          // },
          {
            id: 'contact-list-code-component',
            title: 'Liste des codes origine',
            auth: [
              ROLE_ORIGIN_ALL,
              ROLE_ORIGIN_LIST,
              ROLE_SUPER_ADMIN,
              ROLE_ADMIN
            ],
            type: 'item',
            url: '/contact/origins',
            translate: 'origin_code_list'
          },
          {
            id: 'contact-add-code-component',
            title: 'Ajouter un code',
            auth: [
              ROLE_ORIGIN_LIST,
              ROLE_ORIGIN_ADD,
              ROLE_SUPER_ADMIN,
              ROLE_ADMIN
            ],
            type: 'item',
            url: '/contact/origin/add',
            translate: 'origin_code_add'
          }
        ]
      }
    ]
  },
  {
    id: 'access',
    title: 'Accès',
    display: 'reseau',
    auth: [
      ROLE_USERMANAGER_LIST,
      ROLE_USERMANAGER_ADD,
      ROLE_GROUP_LIST,
      ROLE_GROUP_ADD,
      ROLE_ADMIN,
      ROLE_SUPER_ADMIN,
      ROLE_COLLABORATOR_MANAGERS_SHOW
    ],
    type: 'group',
    icon: AppsIcon,
    translate: 'access',
    children: [
      {
        display: 'reseau',
        id: 'user-component',
        title: 'Utilisateurs & Groupes',
        auth: [
          ROLE_GROUP_LIST,
          ROLE_GROUP_ADD,
          ROLE_USERMANAGER_LIST,
          ROLE_USERMANAGER_ADD,
          ROLE_ADMIN,
          ROLE_SUPER_ADMIN,
          ROLE_COLLABORATOR_MANAGERS_SHOW
        ],
        type: 'collapse',
        icon: UserIcon,
        url: '/users',
        translate: 'users_and_groups',
        children: [
          {
            id: 'users-list-component',
            title: 'Liste des utilisateurs',
            auth: [
              ROLE_USERMANAGER_ALL,
              ROLE_USERMANAGER_LIST,
              ROLE_ADMIN,
              ROLE_SUPER_ADMIN
            ],
            type: 'item',
            url: '/users',
            translate: 'users_list'
          },
          {
            id: 'collaborators-list-component',
            title: 'Liste des collaborateurs',
            auth: [
              // ROLE_FRANCHISE,
              // ROLE_USERMANAGER_ALL,
              // ROLE_USERMANAGER_LIST,
              ROLE_ADMIN,
              ROLE_SUPER_ADMIN,
              // ROLE_COLLABORATOR_MANAGERS_ALL,
              // ROLE_COLLABORATOR_MANAGERS_LIST
            ],
            allowedCountries: [1, 2, 12],
            type: 'item',
            url: '/collaborators',
            translate: 'collaborators'
          },
          {
            id: 'users-groups-list-component',
            title: 'Liste des groupes',
            auth: [
              ROLE_GROUP_ALL,
              ROLE_GROUP_LIST,
              ROLE_ADMIN,
              ROLE_SUPER_ADMIN
            ],
            type: 'item',
            url: '/groups',
            translate: 'groups_list'
          }
        ]
      }
    ]
  },
  {
    id: 'ressource',
    title: 'Resource',
    auth: [
      ROLE_DOC_FILES_LIST,
      ROLE_ADMIN,
      ROLE_SUPER_ADMIN,
      ROLE_FAQ_ALL,
      'ROLE_FRANCHISE',
      ROLE_FAQ_LIST
    ],
    type: 'group',
    icon: DocIcon,
    display: 'reseau',
    translate: 'resources',
    children: [
      {
        display: 'reseau',
        id: 'documentation-component',
        title: 'Documentation',
        auth: [ROLE_DOC_FILES_LIST, ROLE_SUPER_ADMIN],
        icon: DocIcon,
        type: 'item',
        url: '/documentation',
        allowedCountries: [
          1, 2, 3, 5, 6, 7, 8, 9, 12, 14, 16, 17, 20, 21, 22, 23, 30, 31, 85,
          130, 173, 188, 226, 232
        ],
        translate: 'dashboard_content_library'
      },
      {
        id: 'dashboard-faq-component',
        title: 'Questions fréquentes',
        type: 'item',
        icon: FaqIcon,
        url: '/faq',
        translate: 'faq',
        auth: ['ROLE_FRANCHISE', ROLE_FAQ_ALL, ROLE_FAQ_LIST, ROLE_SUPER_ADMIN]
      },
      {
        id: 'terms',
        title: 'Termes & Conditions',
        display: 'reseau',
        type: 'collapse',
        icon: TermsIcon,
        url: '/terms',
        translate: 'terms_nav',
        children: [
          {
            id: 'CGU',
            title: 'CGU',
            type: 'item',
            url: '/terms',
            translate: 'TOU'
          },
          {
            id: 'confidentiality-agreement',
            title: 'Politique de confidentialité',
            type: 'item',
            url: '/privacy-policy',
            translate: 'privacy_policy'
          },
          {
            id: 'cookies-policy',
            title: 'Politique de gestion des cookies',
            type: 'item',
            url: '/cookies-policy',
            translate: 'cookies_policy'
          }
        ]
      }
    ]
  },
  {
    id: 'dashboard-menu',
    title: 'Dashboard',
    type: 'group',
    icon: HomeIcon,
    url: '/dashboard',
    translate: 'dashboard',
    display: 'franchise',
    children: [
      {
        id: 'dashboard-list-component',
        title: 'Dashboard',
        type: 'item',
        icon: HomeIcon,
        url: '/dashboard',
        translate: 'home_dashboard',
        exact: true
      },
      {
        id: 'dashboard-franchisee-account-component',
        title: 'Mon compte',
        type: 'item',
        icon: ProfilIcon,
        url: '/profile',
        translate: 'dashboard_account',
        children: [
          {
            id: 'dashboard-manager-component',
            title: 'Gestion des managers',
            type: 'item',
            url: '/profile/managers',
            translate: 'dashboard_account'
          },
          {
            id: 'dashboard-custom-request-component',
            title: 'Demande de personnalisation des documents',
            type: 'item',
            url: '/profile/custom-request',
            translate: 'dashboard_account'
          }
        ]
      },
      {
        id: 'dashboard-franchisee-team',
        title: 'Mon équipe',
        type: 'item',
        icon: TeamIcon,
        url: '/collaborators',
        translate: 'dashboard_team',
        allowedCountries: [1, 2, 12],
        auth: [
          ROLE_SUPER_ADMIN,
          FRANCHISEE_COLLABORATOR_MANAGERS_ALL,
          FRANCHISEE_COLLABORATOR_MANAGERS_LIST
        ]
      },
      {
        id: 'dashboard-minisite-component',
        title: 'Mini-site',
        type: 'item',
        icon: MinisiteIcon,
        url: '/dashboard/minisite',
        translate: 'dashboard_mini_site'
      },
      {
        id: 'dashboard-mass-admin-component',
        title: 'Administration en masse',
        type: 'item',
        icon: MassAdminIcon,
        url: '/mass-administration',
        translate: 'mass_administration',
        auth: [FRANCHISEE_BULK_PRICES_AND_OPERATIONS_ALL]
      },
      {
        id: 'dashboard-codes-component',
        title: 'Mes codes',
        type: 'item',
        icon: PromoIcon,
        url: '/my-codes',
        translate: 'my_codes',
        allowedCountries: [1],
        allowedBrands: [1, 2, 4, 5, 6, 7, 30, 31, 32, 33, 34, 35, 36],
        auth: [ROLE_SUPER_ADMIN, FRANCHISEE_CODES_LIST]
      },
      {
        id: 'dashboard-content_library-component',
        title: 'Bibliothèque de contenus',
        type: 'item',
        translate: 'dashboard_content_library',
        display: 'franchise',
        icon: LibraryIcon,
        url: '/documentation',
        allowedCountries: [
          1, 2, 3, 5, 6, 7, 8, 9, 12, 14, 16, 17, 20, 21, 22, 23, 30, 31, 85,
          130, 173, 188, 226, 232
        ],
        auth: [FRANCHISEE_LIBRARY_CONTENT_ALL, FRANCHISEE_LIBRARY_CONTENT_LIST]
      },
      {
        id: 'dashboard-faq-component',
        title: 'FAQ',
        type: 'item',
        icon: FaqIcon,
        url: '/faq',
        translate: 'FAQ',
        auth: [FRANCHISEE_FAQ_ALL, FRANCHISEE_FAQ_LIST]
      }
    ]
  },
  {
    id: 'access-to-menu',
    title: 'AccesTo',
    type: 'group',
    icon: HomeIcon,
    translate: 'access_to',
    display: 'franchise',
    allowedCountries: [1, 2, 3, 5, 8, 12],
    children: [
      {
        id: 'dashboard-list-component',
        title: 'Dashboard',
        allowedCountries: [1, 8],
        type: 'item',
        icon: StarIcon,
        url: 'https://critizr.com/pro/login/',
        translate: 'feedbacks',
        exact: true
      },
      {
        id: 'dashboard-account-component',
        title: 'Mon compte',
        allowedCountries: [1],
        type: 'item',
        icon: FidelityIcon,
        url: '/fidelity',
        translate: 'dashboard_loyalty_campaign'
      },
      {
        id: 'dashboard-formation-component',
        title: 'Formation',
        type: 'item',
        allowedCountries: [1, 12, 2, 3, 5],
        icon: FormationIcon,
        url: 'https://provalliance.riseup.ai/',
        translate: 'training',
        exact: true
      },
      {
        id: 'dashboard-product-order-component',
        title: 'Commande de produits',
        type: 'item',
        allowedCountries: [1],
        icon: BottleIcon,
        url: 'https://csp-provalliance.com/',
        translate: 'product_order',
        exact: true
      },
      {
        id: 'dashboard-pub-component',
        title: 'Publicité digitales',
        type: 'item',
        allowedCountries: [1],
        icon: SpeakerIcon,
        url: 'https://pub-digitales.provalliance.com',
        translate: 'digital_pub',
        exact: true
      },
      {
        id: 'dashboard-maison-component',
        title: 'Maisons du monde',
        type: 'item',
        icon: WorldHouseIcon,
        allowedCountries: [1],
        allowedBrands: [1, 2, 4, 5, 6, 7, 30, 31, 32, 33, 34, 35, 36],
        url: 'https://www.maisonsdumonde.com/FR/fr',
        selectedBrandUrl: {
          fp: 'https://www.maisonsdumonde.com/FR/fr/c/franck-provost-n324a6a999dfc19c2584da2e53b2f688b7c0412b',
          jld: 'https://www.maisonsdumonde.com/FR/fr/c/jean-louis-david-n6d95703bb6a5a6d1fdabc728617a0d97e858ec6',
          cco: 'https://www.maisonsdumonde.com/FR/fr/c/coiff-co-neba358fd043d0289024c1c41fa6bf6d5053a68c',
          sa: 'https://www.maisonsdumonde.com/FR/fr/c/saint-algue-n6b78ee9520cbc694d85345ace8e42dba03898e9',
          in: 'https://www.maisonsdumonde.com/FR/fr/c/l-atelier-intermede-ne767615b14a9d05fff784f5ef92973989bb1522',
          tbc: 'https://www.maisonsdumonde.com/FR/fr/c/the-barber-company-nc887c3c28224ed0eb995f65416702e04e85fa31'
        },
        translate: 'world_house',
        exact: true
      },
      {
        id: 'dashboard-vistaprint-component',
        title: 'Vistaprint',
        type: 'item',
        allowedCountries: [1],
        allowedBrands: [2, 4, 6, 7, 34],
        icon: VistaprintIcon,
        url: 'https://provaillance.ourproshop.fr/',
        translate: 'vistaprint',
        exact: true
      },
      {
        id: 'dashboard-alma-payment-3x',
        title: 'Paiement en 3x',
        type: 'item',
        icon: AlmaIcon,
        url: 'https://dashboard.getalma.eu/login',
        allowedCountries: [1],
        translate: 'payment_x3',
      },
      {
        id: 'dashboard-mia-component',
        title: 'Mia',
        type: 'item',
        icon: MiaIcon,
        url: 'https://mia.salonsprovalliance.fr/auth?redirect=%2F',
        allowedCountries: [1], // France
        allowedHairdresserTypes: [11], // Succursale
        exact: true
      }
    ]
  },
  {
    id: 'termsconditions',
    title: 'Terms',
    type: 'group',
    icon: HomeIcon,
    url: '/terms',
    translate: 'terms_nav',
    display: 'franchise',
    children: [
      {
        id: 'CGU',
        title: 'CGU',
        type: 'item',
        icon: BalanceIcon,
        url: '/terms',
        translate: 'TOU'
      },
      {
        id: 'confidentiality-agreement',
        title: 'Politique de confidentialité',
        icon: BalanceIcon,
        type: 'item',
        url: '/privacy-policy',
        translate: 'privacy_policy'
      },
      {
        id: 'cookies-policy',
        title: 'Politique de gestion des cookies',
        type: 'item',
        url: '/cookies-policy',
        translate: 'cookies_policy'
      }
    ]
  }
];

export default navigationConfig;
